import { IItemCache } from '@ms/items-view/lib/private/models/IItemCacheObserver';
import { KeyFacet } from '@ms/items-view/lib/private/models/KeyFacet';
import { Facet } from '@ms/items-view/lib/private/models/Facet';
import { IExpression, IDictionary } from '@ms/utilities-custom-formatter/lib/ICustomFormatter';

export interface ICustomFormatterRowRendererProps {
  itemSetKey: string;
  itemKey: string;
  rowIndex: number;
}

export interface ICustomFormatterTileRendererProps {
  itemSetKey: string;
  rowIndex: number;
  itemKey: string;
}

export interface ICustomFormatterColumnRendererProps {
  itemKey: string;
  rowIndex: number;
  customFormatter: string | undefined;
  fieldName: string;
  schema: IDictionary;
}

export interface ICustomFormatterRowRendererWithSelectionProps {
  itemSetKey: string;
  itemKey: string;
  rowIndex: number;
  formatter: string | undefined;
}

export interface ICustomFormatterTileRendererWithSelectionProps {
  itemSetKey: string;
  itemKey: string;
  rowIndex: number;
  formatter?: string | undefined;
}

export interface ICustomFormatterEvaluateExpressionProps {
  expression: string | IExpression;
  itemKey: string;
  itemSetKey: string;
  rowIndex: number;
}

export interface ICustomFormatterFeature {
  /**
   * Custom render a row with no selection UX
   */
  rowRenderer: React.ComponentType<ICustomFormatterRowRendererProps>;

  /**
   * Custom render a row with selection UX
   */
  rowRendererWithSelection: React.ComponentType<ICustomFormatterRowRendererWithSelectionProps>;

  /**
   * Custom render a column
   */
  columnRenderer: React.ComponentType<ICustomFormatterColumnRendererProps>;

  /**
   * Evaluate an expression specified by expression, and output a string (the result of the expression).
   * Used to specify custom class names on a row.
   */
  evaluateExpression: (itemCache: IItemCache, props: ICustomFormatterEvaluateExpressionProps) => string;
}

export interface ICustomTileFormatterFeature {
  /**
   * Custom render a row with no selection UX
   */
  tileRenderer: React.ComponentType<ICustomFormatterTileRendererProps>;

  tileRendererWithSelection: React.ComponentType<ICustomFormatterTileRendererWithSelectionProps>;
}

export const customFormatterFeatureFacet = new Facet<ICustomFormatterFeature>('customFormatterFeature');

export const customTileFormatterFeatureFacet = new Facet<ICustomTileFormatterFeature>('customTileFormatterFeature');

export const customFormatterFeatureKeyFacet = new KeyFacet<{}>('customFormatterFeature', {});
